import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionLabel } from './ui/SectionLabel';
import { PROBLEMAS } from '../data/content';
export function Problem() {
  return <section className="w-full bg-ink-soft px-5 py-16 sm:px-8 sm:py-24" data-id="element-145" data-mp="2bfpumg5fkqs4">
      <div className="mx-auto max-w-4xl" data-id="element-146" data-mp="2bfg48rgh4hlw">
        <SectionLabel data-id="element-147" data-mp="2gekellf4wldt">El problema que nadie nombra</SectionLabel>
        <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight text-white sm:text-5xl" data-id="element-148" data-mp="2ggx0uarxdhwo">
          ¿Cuántas veces más vas a intentar sola?
        </h2>
        <p className="mt-4 font-display text-lg font-semibold text-violeta-300" data-id="element-149" data-mp="26hely8qvgmbh">
          No falta fuerza. Falta un sistema.
        </p>

        <ul className="mt-10 space-y-3" data-id="element-150" data-mp="1sneuuv62p8y8">
          {PROBLEMAS.map(problema => <li key={problema} className="flex gap-3 rounded-2xl border border-ink-line bg-ink p-4 sm:p-5" data-id="element-151" data-mp="1wr37vtdh4wqv">
              <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-400" aria-hidden="true" data-id="element-152" data-mp="1nqepkmh1sa86" />
              <p className="text-sm leading-relaxed text-violeta-100/85 sm:text-base" data-id="element-153" data-mp="t8dprpv3uf5t">
                {problema}
              </p>
            </li>)}
        </ul>

        <div className="mt-12 rounded-3xl border border-violeta-600/30 bg-ink p-6 sm:p-9" data-id="element-154" data-mp="129k5vxtudnyj">
          <h3 className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-155" data-mp="xbabvqjustei">
            ¿Y si este fuera el último ciclo que repetís sola?
          </h3>
          <p className="mt-4 text-sm leading-relaxed text-violeta-100/75 sm:text-base" data-id="element-156" data-mp="9jla7jl56skw">
            Hay un momento en el baño. Después de otra discusión. Con vos disculpándote por algo que
            no hiciste. Llorando en silencio para que no te escuche.
          </p>
          <p className="mt-3 text-sm leading-relaxed text-violeta-100/75 sm:text-base" data-id="element-157" data-mp="ejheljxr4m0z">
            No faltaba fuerza. Faltaba un sistema. Un mapa claro, con herramientas reales, para la
            realidad argentina.
          </p>
          <blockquote className="mt-6 border-l-2 border-violeta-500 pl-5 font-display text-lg font-semibold leading-snug text-violeta-200 sm:text-xl" data-id="element-158" data-mp="1lymjl2llga85">
            “No es que no podás salir. Es que nadie te dio las herramientas correctas. Hasta ahora.”
          </blockquote>
          <p className="mt-6 text-sm leading-relaxed text-violeta-100/75 sm:text-base" data-id="element-159" data-mp="1vp7mv3c7q2xe">
            Los 6 Tomos responden una sola pregunta: ¿qué necesita una mujer argentina para entender
            lo que vive, protegerse, salir y no volver?
          </p>
          <p className="mt-4 font-display text-sm font-bold text-white sm:text-base" data-id="element-160" data-mp="17y22cavbumgr">
            +500 mujeres en Argentina ya lo tienen.
          </p>
        </div>
      </div>
    </section>;
}